const initialState = {
  searchLists: [],
  loadingSearch: false,
  searchCount: 0,
  errorsSearch: null,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SEARCH_LIST_PENDING":
      return { ...state, loadingSearch: true, searchLists: [], errorsSearch: null };
    case "GET_SEARCH_LIST_FULFILLED":
      return {
        ...state,
        loadingSearch: false,
        searchLists: action.payload || [],
        searchCount: action.count ?? 0,
        errorsSearch: null,
      };
    case "GET_SEARCH_LIST_REJECTED":
      return {
        ...state,
        loadingSearch: false,
        searchLists: [],
        errorsSearch: action.payload,
      };
    default:
      return state;
  }
};

export default searchReducer;
